<template>
  <div class="input-container">
    <input
      :value="value"
      :id="id"
      :name="name"
      :required="required"
      class="form-control birthday-input"
      type="date"
    >
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "DateInput",
  props: {
    id: {
      required: true,
      type: String
    },
    name: {
      required: false,
      type: String,
      default: "date"
    },
    required: {
      required: false,
      type: Boolean,
      default: false
    },
    value: {
      required: false,
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.input-container {
  display: inline-block;
}
</style>
